import { Button } from "@mantine/core";
import { useState } from "react";
import { Link } from "react-router";
import type { WizardMissingData } from "../../../../../utils/backend-types";
import { AssignmentType } from "../../EnergyWizard";
import "./MeterAssignment.scss";

type MeterAssignmentProps = {
  done: boolean;
  missingData: Array<WizardMissingData>;
  isBlocked: boolean;
  updateSiteWizard: (type: AssignmentType) => Promise<void>;
};

function MeterAssignment({
  done,
  missingData,
  isBlocked,
  updateSiteWizard
}: MeterAssignmentProps) {
  const [isSpinning, setIsSpinning] = useState(false);
  const hasMissingData = missingData && missingData.length > 0;

  function onClickSubmit() {
    setIsSpinning(true);
    updateSiteWizard(AssignmentType.MeasurementData).then(() => {
      setIsSpinning(false);
    });
  }
  function getComponentByStep() {
    if (isBlocked) {
      return (
        <div className="missing-data-container">
          Der digitale Zwilling Ihrer Liegenschaft entspricht nicht den
          opti.node-Standards, so dass wir keine Aussage zur Datenverfügbarkeit
          treffen können. Bitte setzen Sie sich mit unserem Onboarding-Team in
          Verbindung
        </div>
      );
    } else if (hasMissingData && !done) {
      return (
        <div className="missing-data-container">
          <Button
            className="missing-data-button"
            color="primary"
            component={Link}
            to={"historischeMessdaten"}
            variant={"default"}
          >
            Daten bereitstellen
          </Button>
        </div>
      );
    } else if (!done) {
      return (
        <div className="missing-data-container">
          <Button
            className="missing-data-button"
            color="primary"
            loading={isSpinning}
            variant={"default"}
            onClick={() => onClickSubmit()}
          >
            Zählerdaten bestätigen
          </Button>
        </div>
      );
    }
  }
  return <div className="MeterAssignment">{getComponentByStep()}</div>;
}

export { MeterAssignment };
